import { JsonDataBlobComponentFragment } from '@graphql/generated';
import { JsonComponentSwitch, JsonComponentSwitchProps } from './JsonComponentSwitch';
import { useCustomComponentStateContext } from '@website-editor/features/custom-page/context/CustomComponentStateContext/CustomComponentState.context';
import React from 'react';
import { CustomComponentsWrapperType } from '@website-editor/customComponents/CustomComponents';

export const JsonComponentEditor = (props: Omit<JsonComponentSwitchProps, 'componentData'> & { type: string }) => {
  const { customComponentBlockData: componentData } = useCustomComponentStateContext<JsonDataBlobComponentFragment>();

  if (!componentData) {
    // This is an invalid state. The convention for these Custom Components is
    // that the edit button stores the state of the component to edit,
    // and then the editor retrieves it to operate on.
    throw new Error('Editor opened without first storing state.');
  }

  return (
    <JsonComponentSwitch
      {...props}
      wrapperType={CustomComponentsWrapperType.SingleComponent}
      componentData={componentData}
    />
  );
};
